<template>
  <label class="chip-wrap" :class="[border, size, bg, ftcolor]" @click="clickChip">
    <slot name="chipname"></slot>
  </label>
</template>
<script>
export default {
  props: {
    border: {
      type: String,
      default: '', // br-black800, br-black300
      required: false
    },
    size: {
      type: String,
      default: '', // md,sm
      required: false
    },
    bg: {
      type: String,
      default: '', // bg-black700, bg-black200
      required: false
    },
    ftcolor: {
      type: String,
      default: '', // font-black700,font-black500, font-white
      required: false
    }
  },
  emits: ['click-chip'],
  methods: {
    clickChip() {
      this.$emit('click-chip');
    }
  }
};
</script>
<style scoped src="@/assets/css/chipcomponent/chipcomponent.css"></style>
